import { QueryResult } from "@/api/utils/types"
import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"
import { GetComplaintsForAccountNumberQuery } from "@/api/hasura/generated/graphql"
import { ComplaintParser } from "@/models/complaint/complaintParser"
import { IComplaint } from "@/models/complaint/complaint.types"

export interface IComplaintService {
  getForAccount(accountNumber: string): QueryResult<IComplaint[]>
}

class ComplaintServiceClass implements IComplaintService {
  getForAccount(accountNumber: string): QueryResult<IComplaint[]> {
    return useQuery({
      ...HasuraQueries.account.complaints(accountNumber),
      placeholderData: [],
      parserFn: (raw: GetComplaintsForAccountNumberQuery) => {
        return raw.complaint.map((c) => ComplaintParser.toDomain(c))
      },
      useRawResponse: true,
      enabled: !!accountNumber,
    })
  }
}

export const ComplaintService = new ComplaintServiceClass()
